export function getCookieValue(cookieName: string): string {
    const name = cookieName + '=';
    const decodedCookie = decodeURIComponent(document.cookie);
    const cookieArray = decodedCookie.split(';');

    for (let i = 0; i < cookieArray.length; i++) {
      const cookie = cookieArray[i].trim();
      if (cookie.indexOf(name) === 0) {
        return cookie.substring(name.length, cookie.length);
      }
    }
    return '';
}

export function extractTealiumId(input: string): string | null {
    const regex = /v:([^$]*)\$/;
    const match = input?.match(regex);
    return match ? match[1] : null;
}


